import React from 'react';
import Icon from '../../common/icons/icons';

function NotificationDropDownAction({
  openState,
  setOpenState,
  options,
  selectedOption,
  setSelectedOptions,
}) {
  return (
    <div className={`dropdown ${openState ? 'active' : ''}`}>
      <button
        className="dropdown__head"
        onClick={() => setOpenState((prev) => !prev)}
      >
        <Icon icon="dots" className="icon" />
      </button>
      <div className="dropdown__body">
        {options.map((data, idx) => (
          <button
            key={idx}
            className={`dropdown__link ${
              selectedOption.name === data.name ? 'selected' : ''
            }`}
            onClick={() => {
              setSelectedOptions(data);
              setOpenState(false);
            }}
          >
            {data.name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default NotificationDropDownAction;
